import { GridApi, IRowNode } from "ag-grid-community";
import { SavingsOpportunity } from "@/services/cloudchipr.api";
import { savingsOpportunityForecastEOMColumnField } from "@/components/pages/savings-opportunities/components/savingsOpportunitiesTableColumns";

export type SavingsOpportunityCostFieldKeys = keyof Pick<
  SavingsOpportunity,
  | "monthly_savings"
  | "estimated_monthly_price"
  | "current_monthly_price"
  | typeof savingsOpportunityForecastEOMColumnField
>;

export const generateTotalFromUniqueItemsByGridApiAndKey = (
  gridApi: GridApi | null,
  dataKey: SavingsOpportunityCostFieldKeys,
) => {
  const uniqueItemsCosts: Record<string, number> = {};

  gridApi?.forEachNodeAfterFilter((node) =>
    generateTotalFromUniqueItemsNodeByKey(node, uniqueItemsCosts, dataKey),
  );

  return Object.values(uniqueItemsCosts).reduce((sum, num) => sum + num, 0);
};

export const generateTotalFromUniqueItemsNodeByKey = (
  node: IRowNode<SavingsOpportunity>,
  uniqueItemsCosts: Record<string, number>,
  dataKey: SavingsOpportunityCostFieldKeys,
) => {
  const rowData = node.data;
  const key = rowData?.resource_id ?? rowData?.resource_name ?? "";

  if (!uniqueItemsCosts[key]) {
    uniqueItemsCosts[key] = rowData?.[dataKey] ?? 0;
  } else {
    uniqueItemsCosts[key] = Math.max(
      uniqueItemsCosts[key],
      rowData?.[dataKey] ?? 0,
    );
  }
};
